import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/recreateIdentity/user.recreateIdentity.mutation.gql"
import type {
  UserRecreateIdentityMutation,
  UserRecreateIdentityMutationVariables,
} from "@/v2-backoffice-client/user/recreateIdentity/__types__/user.recreateIdentity.mutation"

type Options = MutationHookOptions<
  UserRecreateIdentityMutation,
  UserRecreateIdentityMutationVariables
>

export function useUserRecreateIdentityMutation(options?: Options) {
  return useMutation<
    UserRecreateIdentityMutation,
    UserRecreateIdentityMutationVariables
  >(mutation, options)
}
